import {
  AppState,
  AppLocale,
  RootAction,
  ChangeLocale,
  ChangeLocaleAction,
} from "./types";

const initLocale: AppLocale = window.localStorage.getItem('locale') as AppLocale;

export const defaultState = {
  locale: initLocale || "en" as AppLocale,
};

export function reducer(
  state: AppState = defaultState,
  action: RootAction
): AppState {
  switch (action.type) {
    case ChangeLocale: {
      return {
        ...state,
        locale: action.payload,
      };
    }
  }
  return state;
}

export function changeLocale(locale: AppLocale): ChangeLocaleAction {
  window.localStorage.setItem('locale', locale);
  return {
    type: ChangeLocale,
    payload: locale,
  };
}



// WEBPACK FOOTER //
// ./src/redux/app.ts